import LocalStorage from '../../service/localstorage';
import service from '../../service/apolloclient.service';
import { ZENDESKTOKENTYPE } from '../common/constants';

const storage = new LocalStorage();
const MIN = (60 * 1000);

export default class Token {
    static getRosterMetaInfoMap(rosterid: string) {
       let decToken = this.decodeToken();
       console.log('decToken', decToken);
       let uidrosteridmetainfomaps: any = '';
       if (decToken !== undefined ) {
        uidrosteridmetainfomaps = decToken.uidrosteridmetainfomap.filter
                                            ( (x: any) => x.rosterid === rosterid)[0].uidrosteridmetainfomaps;
        console.log('uidrosteridmetainfomaps', uidrosteridmetainfomaps);
       }
       return uidrosteridmetainfomaps ;
    }

    static decodeToken(t: any = '') {
        let token ;
        if (t === '') {
            token = storage.getToken();   
        } else { token = t ; }
        if (token !== undefined) {
            let base64Url = token.split('.')[1];   
            let base64 = base64Url.replace('-', '+').replace('_', '/');
            console.log('decodedtoken', JSON.parse(window.atob(base64)));
            return JSON.parse(window.atob(base64));
        }
    }

    static async verifyZendeskToken(type: number, token: any, regenerate: boolean = false) {        

        if (token === undefined || token === '') {
            return token = '';
        }
        
        let skew = type === ZENDESKTOKENTYPE.SSO ? (2 * MIN) : (2 * MIN * 60);
        let decodedtoken = token !== undefined ? this.decodeToken(token) : '';
        let zEpochMilli = new Date(decodedtoken.iat * 1000).getTime();  // iat in seconds     
        let currentMin = (new Date).getTime(); 
        if ((currentMin > (zEpochMilli + skew)) || regenerate) {     // Zendesk allows up to three minutes clock skew 
            console.log('verifyZendeskToken generating token.');
            let ser = new service();    
            return await ser.generateZendeskToken(type)
            .then((newtoken) => { 
                console.log('newtoken: ', newtoken);
                return newtoken !== undefined ? newtoken.token : '';
            });
        }

        console.log('token not generated.');
        return '';
    }

}


// WEBPACK FOOTER //
// ./src/components/common/token.tsx